import { getElement } from '../../common/asyncElementGetter';

const modalCityLabelOpacity = async({ document }) => {
  const cityNameElement = await getElement('#city_selected_id', false, true, 500, 30);
  const cityName = cityNameElement.textContent;
  const modalCityElement = document.querySelectorAll('#modalCity .form-check-label');
  modalCityElement.forEach(element => {
    if (cityName === element.textContent) {
      element.classList.add('fw-bold');
    }
  });
};

export default modalCityLabelOpacity;
